/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Compile_FailedInputs */

const cs_builder_compile_failed = /** @type {(inputs: Builder_Compile_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument se nepodařilo zkompilovat`)
};

const en_builder_compile_failed = /** @type {(inputs: Builder_Compile_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not compile this document`)
};

/**
* | output |
* | --- |
* | "Could not compile this document" |
*
* @param {Builder_Compile_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_compile_failed = /** @type {((inputs?: Builder_Compile_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Compile_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_compile_failed(inputs)
	return cs_builder_compile_failed(inputs)
});